import { FC } from 'react';
import {
  CardRadioButton,
  IconStyle,
  MLPVersion,
  RadioButtonAlignment,
  Theme,
  useTranslation,
} from '@nextgen-web-framework/all';
import type { IconPropInterface } from '@nextgen-web-framework/all';
import { ICheckoutShippingTypeProps } from '../types/propTypes';
import { ShippingTypeEnums, shippingOptions } from '../../common/config/checkoutConstants';
import { DataFlowEnum } from '../../common/types/CheckoutType';
import styles from './CheckoutShippingType.module.scss';

export const CheckoutShippingType: FC<ICheckoutShippingTypeProps> = ({
  shippingType,
  onChangeCB,
  isDeliveryDisabled,
  isPickupDisabled,
  dataFlow,
  columnView,
}: ICheckoutShippingTypeProps) => {
  const t = useTranslation();
  return (
    <div
      className={`${styles['checkout-shipping-type-container']} ${
        dataFlow !== DataFlowEnum.CHECKOUT && styles['non-checkout-shipping-type-container']
      } ${columnView && styles['column-view']}`}
      data-testid="checkout-shipping-type-container"
    >
      {shippingOptions?.map((option) => (
        <CardRadioButton
          className={
            shippingType == option.type
              ? `${styles['checkout-shipping-type-radio']} ${styles['selected']}`
              : `${styles['checkout-shipping-type-radio']}`
          }
          icon={{
            iconName: option.icon as IconPropInterface['iconName'],
            iconStyle: IconStyle.SOLID,
          }}
          id={option.id}
          key={option.id}
          label={t(option.label)}
          mlpVersion={MLPVersion.ONE}
          onClick={() => onChangeCB(option.type)}
          radioButtonAlignment={RadioButtonAlignment.CENTER}
          theme={shippingType == option.type ? Theme.PURPLE : Theme.BLACK}
          checked={shippingType == option.type}
          disabled={
            (option.type == ShippingTypeEnums.DELIVERY && isDeliveryDisabled) ||
            (option.type == ShippingTypeEnums.PICKUP && isPickupDisabled)
          }
        />
      ))}
    </div>
  );
};

export default CheckoutShippingType;
